import { NO_WRAP } from './../ricos-content';

const ALIGN_CENTER = 'center';

const SIZE_LARGE = 'large';

export const DEFAULTS = Object.freeze({
  type: 'single',
  config: {
    size: SIZE_LARGE,
    alignment: ALIGN_CENTER,
    textWrap: NO_WRAP,
  },
});
